
import { JSX } from "react";

export const formatPrice = (amount: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// Simplified formatters without percentage display
export const formatAmountWithTax = (amount: number): JSX.Element => {
  return <span>{formatPrice(amount)}</span>;
};

export const formatAmountWithDiscount = (amount: number): JSX.Element => {
  return <span>{formatPrice(amount)}</span>;
};

export const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'unpaid':
      return 'bg-yellow-500';
    case 'paid':
      return 'bg-green-500';
    case 'expired':
    case 'cancelled':
      return 'bg-red-500';
    default:
      return 'bg-gray-500';
  }
};
